module.exports = __webpack_public_path__ + "videos/03eb35e5e9580aa9f09cb58cdbd7c3a8.mp4";